export default __webpack_public_path__ + "static/media/twitter_logo.0bafc8d2.svg";